import { render, staticRenderFns } from "./SirensTable.vue?vue&type=template&id=23c944c6&scoped=true"
import script from "./SirensTable.vue?vue&type=script&lang=js"
export * from "./SirensTable.vue?vue&type=script&lang=js"
import style0 from "./SirensTable.vue?vue&type=style&index=0&id=23c944c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c944c6",
  null
  
)

export default component.exports